import React from 'react';
import { FaGoogle, FaFacebookF } from 'react-icons/fa';
import './SocialLogin.css';
import { useTranslation } from 'react-i18next';
import { api } from '../api';

const SocialLogin = () => {
    const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const ap = `${apiBase.replace(/\/$/, '')}/api/`;
    const { t } = useTranslation();

    const handleGoogleLogin = () => {
        window.location.href = `${api}auth/google`;
    };

    const handleFacebookLogin = () => {
        window.location.href = `${api}auth/facebook`;
    };

    return (
        <div className="social-login">
            

            <div className="social-buttons">
                <button
                    className="social-btn google-btn"
                    onClick={handleGoogleLogin}
                    type="button"
                >
                    <FaGoogle className="social-icon" />
                    <span>{t("login.google")}</span>
                </button>

                <button
                    className="social-btn facebook-btn"
                    onClick={handleFacebookLogin}
                    type="button"
                >
                    <FaFacebookF className="social-icon" />
                    <span>{t("login.facebook")}</span>
                </button>
            </div>
            <div className="social-divider">
                <span>{t("login.continueWith")}</span>
            </div>
        </div>
    );
};

export default SocialLogin;